'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';

import { cn } from '@/app/lib/utils/tailwindcss';

interface SectionHeaderProps {
  children: ReactNode;
  linkUrl?: string;
  color: string; // e.g. '--color-g-00'
}

export default function SectionHeader({ children, linkUrl, color }: SectionHeaderProps) {
  // --color-g-00 -> text-g-00
  const textColor = color.replace('--color-', 'text-');

  return (
    <header className="flex w-full">
      {linkUrl && (
        <Link href={linkUrl} className="flex w-fit items-center gap-1">
          <h3 className={cn('typo-heading-3', textColor)}>{children}</h3>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L11 8L6 3" stroke={`var(${color})`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
      )}

      {!linkUrl && <h3 className={cn('typo-heading-3', textColor)}>{children}</h3>}
    </header>
  );
}
